import { call, takeLatest } from 'redux-saga/effects';

import { CorporateLeadApi } from '@apis/CorporateLeadApi';
import { SagaPayload } from '@utils/typescript';

import { corporateLeadCreate } from './action';
import { CorporateLeadCreatePayload } from './type';

function* handleCorporateLeadCreate({ payload }: SagaPayload<CorporateLeadCreatePayload>) {
  try {
    yield call(CorporateLeadApi.create, payload);
  } catch (error) {
    console.error('Failed to create corporate lead:', error);
  }
}

export default function* () {
  yield takeLatest(corporateLeadCreate, handleCorporateLeadCreate);
}
